import { tv } from 'tailwind-variants';
import { defineComponent, h } from 'vue';

export const tooltip = tv({
  slots: {
    root: [
      'bg-white dark:bg-brand-gray-15 px-2 py-1 leading-[14px] text-pretty',
      'pointer-events-none relative overflow-y-auto shadow-brand-400 rounded-lg max-w-[300px] before:content-[""]',
      'before:absolute before:inset-0 before:z-10 before:rounded-lg before:pointer-events-none before:mix-blend-luminosity before:shadow-brand-bevel-100',
    ],
    label: 'text-sm text-brand-gray-15 dark:text-brand-gray-2 text-pretty',
  },
});

export const tooltipContent = defineComponent({
  name: 'TooltipContent',
  props: {
    label: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    styleAttrs: {
      type: Object,
      required: true,
    },
    showDelay: {
      type: Number,
      default: 0,
    },
    hideDelay: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    return () =>
      h(
        'div',
        {
          class: tooltip(),
          style: {
            display: props.isOpen ? 'block' : 'none',
            position: 'absolute',
            zIndex: 1000,
            ...props.styleAttrs,
          },
        },
        [props.label]
      );
  },
});
